import React from 'react';
import PropTypes from 'prop-types';
import { ChevronDownIcon } from '../../layouts/loginless-common/icons';
import './plan-dropdown.m.css';

export const PlanDropdown = ({
  plans = [],
  currentPlan = {},
  initialPlan = {},
  isOpen = false,
  groupId,
  onToggle,
  onSelectPlan,
  mode = 'light'
}) => {
  const singlePlan = plans.length <= 1;
  const displayTitle = currentPlan?.title || initialPlan?.title || '';
  const dropdownWrapperStyle = `plan-dropdown-wrapper ${isOpen ? 'open' : ''} ${mode === 'dark' ? 'dark' : ''}`.trim();
  const dropdownBtnStyle = `plan-dropdown-btn ${isOpen ? 'open' : ''} ${singlePlan ? 'single-plan' : ''}`.trim();

  return (
    <div styleName={dropdownWrapperStyle} data-dropdown-wrapper="true" data-test-id="subscription-card-plan-dropdown">
      <button
        type="button"
        styleName={dropdownBtnStyle}
        title={displayTitle}
        onClick={(e) => {
          e.stopPropagation();
          if (!singlePlan) {
            onToggle(groupId);
          }
        }}
        disabled={singlePlan}
      >
        <span styleName="plan-dropdown-text" title={displayTitle}>{displayTitle}</span>
        {!singlePlan && (
          <span styleName={`plan-dropdown-chevron ${isOpen ? 'rotated' : ''}`}>
            <ChevronDownIcon />
          </span>
        )}
      </button>

      {!singlePlan && isOpen && (
        <div styleName="plan-dropdown-menu">
          {plans.map((p) => {
            const isPlanActive = p.id === currentPlan?.id;
            return (
              <div
                key={p.id}
                styleName={`plan-dropdown-item ${isPlanActive ? 'active' : ''}`}
                title={p.title}
                onClick={(e) => {
                  e.stopPropagation();
                  onSelectPlan(p, groupId);
                }}
              >
                <span styleName="item-title">{p.title}</span>
                {isPlanActive && <span styleName="item-check">✓</span>}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

PlanDropdown.propTypes = {
  plans: PropTypes.array,
  currentPlan: PropTypes.object,
  initialPlan: PropTypes.object,
  isOpen: PropTypes.bool,
  groupId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onToggle: PropTypes.func.isRequired,
  onSelectPlan: PropTypes.func.isRequired,
  mode: PropTypes.string
};
